const keyFor = (args: any[]): string => JSON.stringify(args);

const withCache = <T, Args extends any[]>(fn: (...args: Args) => Promise<T>) => {
  const cache = new Map<string, Promise<T>>();

  const wrapper = async (...args: Args): Promise<T> => {
    const key = keyFor(args);
    const cached = cache.get(key);
    if (cached) {
      return cached;
    }

    const promise = fn(...args).catch((err) => {
      cache.delete(key);
      throw err;
    });
    cache.set(key, promise);
    return promise;
  };

  return wrapper;
};

export { withCache };
